<template>
  <div class="charts-detail-wrap" id="map_detail_exposure_from_data">
    <h2>
      来源及曝光数据
      <img class="img-help" src="@/assets/images/icon_help.png" @click="linkDesc" />
    </h2>
    <div class="charts-chooseDay">
      <!-- 自由选择日期 -->
      <div class="date-box">
        <div class="data-filter">
          <span class="mgr25">选择日期</span>
          <el-date-picker
            v-model="DateData"
            type="daterange"
            align="left"
            unlink-panels
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            :picker-options="DatapickerOptions"
          >
          </el-date-picker>
          <el-button @click="getList" class="search_btn" type="info"
            >查找</el-button
          >
        </div>
        <!--固定周期切换-->
        <div class="date-wrap">
          <el-radio-group
            v-model="userType"
            style="margin-bottom: 30px"
            @change="changeUserType"
          >
            <el-radio-button label="7">7天</el-radio-button>
            <el-radio-button label="30">30天</el-radio-button>
            <el-radio-button label="90">90天</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="download-wrap" @click="exportFn">
        <img src="@/assets/images/icon_export.png" />
        <span>导出数据</span>
      </div>
    </div>
    <p class="model-desc">游戏来源数据</p>
    <div>
      <title-name
        title=" "
        :btn="btnOptions"
        @selectChange="selectChange"
      ></title-name>
      <div>
        <ve-histogram v-if="list.exposureDataFrom.rows.length" :data="list.exposureDataFrom" :extend="extend" :after-set-option="afterSetOption"></ve-histogram>
        <div class="img-no" v-else>
          <img
            class="img-no-data"
            src="../../../assets/images/img_table_no_data.png"
          />
          <div class="noCart">暂无数据</div>
        </div>
      </div>
      <p class="model-desc">曝光转化数据</p>
      <title-name title=" " :btn="lineOptions"></title-name>
      <div>
        <ve-line :data="list.lineData" v-if="list.lineData.rows.length" :extend="chartExtend" :settings="{yAxisType: ['percent']}"></ve-line>
        <div class="img-no" v-else>
          <img
            class="img-no-data"
            src="../../../assets/images/img_table_no_data.png"
          />
          <div class="noCart">暂无数据</div>
        </div>
      </div>
    </div>
    <p class="model-desc data-title">数据总览表</p>
    <el-table id="map_detail_exposure_from_all_data" :data="tableData" border stripe>
      <el-table-column
        prop="dt"
        label="日期"
        sortable
        width="120"
        align="center"
      ></el-table-column>
      <el-table-column label="新增玩家来源" align="center">
        <el-table-column
          align="center"
          sortable
          prop="new_lobby_uin_cnt"
          label="联机大厅推荐"
          width="120"
          v-slot="scope"
        >
          <template>
            {{ toFixedNumber(scope.row.new_lobby_uin_cnt) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="new_startgame_uin_cnt"
          label="开始游戏"
          width="120"
          v-slot="scope"
        >
          <template>
            {{ toFixedNumber(scope.row.new_startgame_uin_cnt) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="new_workshop_uin_cnt"
          label="迷你工坊"
          width="120"
          v-slot="scope"
        >
          <template>
            {{ toFixedNumber(scope.row.new_workshop_uin_cnt) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="new_friend_uin_cnt"
          label="好友来源"
          width="120"
          v-slot="scope"
        >
          <template>
            {{ toFixedNumber(scope.row.new_friend_uin_cnt) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="new_search_uin_cnt"
          label="搜索来源"
          width="120"
          v-slot="scope"
        >
          <template>
            {{ toFixedNumber(scope.row.new_search_uin_cnt) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="new_other_uin_cnt"
          label="其他来源"
          width="120"
          v-slot="scope"
        >
          <template>
            {{ toFixedNumber(scope.row.new_other_uin_cnt) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="new_uin_cnt"
          label="新增玩家人数"
          width="120"
          v-slot="scope"
        >
          <template>
            {{ toFixedNumber(scope.row.new_uin_cnt) }}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="游戏行为来源" align="center">
        <el-table-column
          align="center"
          sortable
          prop="lobby_game_cnt"
          label="联机大厅推荐"
          width="120"
          v-slot="scope"
        >
          <template>
            {{ toFixedNumber(scope.row.lobby_game_cnt) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="startgame_game_cnt"
          label="开始游戏"
          width="120"
          v-slot="scope"
        >
          <template>
            {{ toFixedNumber(scope.row.startgame_game_cnt) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="workshop_game_cnt"
          label="迷你工坊"
          width="120"
          v-slot="scope"
        >
          <template>
            {{ toFixedNumber(scope.row.workshop_game_cnt) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="friend_game_cnt"
          label="好友来源"
          width="120"
          v-slot="scope"
        >
          <template>
            {{ toFixedNumber(scope.row.friend_game_cnt) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="search_game_cnt"
          label="搜索来源"
          width="120"
          v-slot="scope"
        >
          <template>
            {{ toFixedNumber(scope.row.search_game_cnt) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="other_game_cnt"
          label="其他来源"
          width="120"
          v-slot="scope"
        >
          <template>
            {{ toFixedNumber(scope.row.other_game_cnt) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="all_game_cnt"
          label="游戏次数"
          width="120"
          v-slot="scope"
        >
          <template>
            {{ toFixedNumber(scope.row.all_game_cnt) }}
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="曝光转化（联机大厅推荐）" align="center">
        <el-table-column
          align="center"
          sortable
          prop="ctr_all2"
          label="CTR（整体）"
          width="120"
        >
        </el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="ctr_card_click2"
          label="CTR（地图卡片）"
          width="120"
        >
        </el-table-column>
        <el-table-column
          align="center"
          sortable
          prop="ctr_detail_enter2"
          label="CTR（详情页）"
          width="120"
        >
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getMapExposureFrom } from '@/api/charts';
import { htmlToExcel } from '../../../utils/index';
import titleName from './title-btn.vue';
import { chartExtend } from './chartsStyle';

export default {
  data() {
    return {
      btnOptions: [
        { label: '新增玩家来源', id: '1' },
        { label: '游戏行为来源', id: '2' },
      ],
      lineOptions: [{ label: '曝光转化', id: '1' }],
      DateData: [],
      userType: '7',
      selectChangeValue: '1',
      mapId: 0,
      tableData: [],
      list: {
        exposureDataFrom: {
          rows: [],
          columns: ['日期', '玩家联机大厅推荐', '玩家开始游戏', '玩家迷你工坊', '玩家好友来源', '玩家搜索来源', '玩家其他来源'],
        },
        lineData: {
          rows: [],
          columns: ['日期', 'CTR（整体）', 'CTR（地图卡片）', 'CTR（详情页）'],
        },
      },
      DatapickerOptions: {
        //判断
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcurts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近3个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      extend: {
        yAxis: {
          //是否显示y轴线条
          axisLine: {
            show: true,
          },
          // 纵坐标网格线设置，同理横坐标
          splitLine: {
            show: false,
          },
          // 线条位置
          position: 'left',
        },
        xAxis: {
          axisLine: {
            show: true,
          },
        },
        // series: {
        //   label: { show: true, position: 'top', type: 'bar' },
        // },
      },
      chartExtend: {
        ...chartExtend,
        series: {
          itemStyle: {
            normal: {
              colors: [],
            },
          },
        },
      },
    };
  },
  components: {
    titleName,
  },
  created() {
    this.DateData = [this.filterDate(7), this.filterDate(1)];
    this.mapId = this.$route.query.id;
    this.dataList = {
      playerData: [],
      gamesData: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    afterSetOption(chart) {
      // const name = this.selectChangeValue === '1' ? '新增玩家来源' : '游戏行为来源';
      chart.setOption({
        series: [
          { type: 'bar', barMaxWidth: 30, stack: '堆叠', name: '联机大厅推荐' },
          { type: 'bar', barMaxWidth: 30, stack: '堆叠', name: '开始游戏' },
          { type: 'bar', barMaxWidth: 30, stack: '堆叠', name: '迷你工坊' },
          { type: 'bar', barMaxWidth: 30, stack: '堆叠', name: '好友来源' },
          { type: 'bar', barMaxWidth: 30, stack: '堆叠', name: '搜索来源' },
          { type: 'bar', barMaxWidth: 30, stack: '堆叠', name: '其他来源' },
        ],
      });
    },
    async selectChange(val) {
      this.selectChangeValue = val;
      const obj = {
        '1': ['日期', '联机大厅推荐', '开始游戏', '迷你工坊', '好友来源', '搜索来源', '其他来源'],
        '2': ['日期', '联机大厅推荐', '开始游戏', '迷你工坊', '好友来源', '搜索来源', '其他来源'],
      };
      this.list.exposureDataFrom.columns = obj[val];
      this.list.exposureDataFrom.rows = val === '1' ? this.dataList.playerData : this.dataList.gamesData;
    },
    getList() {
      getMapExposureFrom({
        id: this.mapId,
        start_time: parseInt(this.DateData[0] / 1000, 10),
        end_time: parseInt(this.DateData[1] / 1000, 10),
      }).then(res => {
        if (res.code === 0) {
          // 数据转换
          this.dataList = {
            playerData: [],
            gamesData: [],
          };
          this.list.lineData.rows = [];
          this.tableData = [...res.data.list].sort(function (a, b) {
            const dateA = new Date(a.dt);
            const dateB = new Date(b.dt);
            return dateB - dateA;
          });
          res.data.list.forEach((item) => {
            this.list.lineData.rows.push({
              '日期': item.dt,
              'CTR（整体）': item.ctr_all,
              'CTR（地图卡片）': item.ctr_card_click,
              'CTR（详情页）': item.ctr_detail_enter,
            });
            this.dataList.playerData.push({
              '日期': item.dt,
              '联机大厅推荐': item.new_lobby_uin_cnt,
              '开始游戏': item.new_startgame_uin_cnt,
              '迷你工坊': item.new_workshop_uin_cnt,
              '好友来源': item.new_friend_uin_cnt,
              '搜索来源': item.new_search_uin_cnt,
              '其他来源': item.new_other_uin_cnt,
            });
            this.dataList.gamesData.push({
              '日期': item.dt,
              '联机大厅推荐': item.lobby_game_cnt,
              '开始游戏': item.startgame_game_cnt,
              '迷你工坊': item.workshop_game_cnt,
              '好友来源': item.friend_game_cnt,
              '搜索来源': item.search_game_cnt,
              '其他来源': item.other_game_cnt,
            });
            item.ctr_all2 = this.filterNumber(item.ctr_all);
            item.ctr_card_click2 = this.filterNumber(item.ctr_card_click);
            item.ctr_detail_enter2 = this.filterNumber(item.ctr_detail_enter);
          });
          this.selectChange(this.selectChangeValue);
        }
      });
    },
    sortBy(array, field, sort = 'asc') {
      const sortOpt = {
        asc: (a, b, sortField) => a[sortField] - b[sortField],
        desc: (a, b, sortField) => b[sortField] - a[sortField],
      };
      array.sort((a, b) => sortOpt[sort](a, b, field));
      return array;
    },
    changeUserType(value) {
      this.DateData[0] = this.filterDate(value);
      this.DateData[1] = this.filterDate(1);
      this.getList();
    },
    exportFn() {
      htmlToExcel.getExcel('#map_detail_exposure_from_all_data', `来源及曝光数据-${this.mapId}`);
    },
    filterNumber(val) {
      if (!val) {
        return '';
      }
      const n = Number(val);
      return n ? `${(n * 100).toFixed(2)}%` : val;
    },
    toFixedNumber(val) {
      if (!val) {
        return '';
      }
      const n = Number(val);
      return n ? `${n.toFixed(0)}` : val;
    },
    filterDate(day = 1) {
      const time = new Date(new Date(new Date()).toDateString()).getTime();
      return time - (1000 * 60 * 60 * 24 * Number(day));
    },
    linkDesc() {
      window.open('https://dev-wiki.mini1.cn/courses/article/2349');
    },
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;
.charts-detail-wrap {
  margin-top: 36px;
  h2 {
    font-size: 24px;
  }
  .model-desc {
    color: #999999;
  }
  .charts-title {
    font-size: 20px;
    display: flex;
    justify-content: space-between;
  }
  .charts-chooseDay {
    margin: 20px 0;
    display: flex;
    .date-box {
      display: flex;
      flex: 1;
    }
    .data-filter {
      .mgr25 {
        margin-right: 25px;
      }
      .search_btn {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-left: 0;
        color: #595959;
        border-right: 1px solid #d9d9d9;
        border-top: 1px solid #d9d9d9;
        border-bottom: 1px solid #d9d9d9;
        background-color: #f4f4f5;
      }
    }
    .date-wrap {
      margin-left: 15px;
    }
    .choose-label {
      margin-right: 24px;
    }
    .download-wrap {
      cursor: pointer;
      color: #2b6ddf;
      font-size: 14px;
      padding-top: 10px;
      margin-right: 10px;
      img {
        margin-right: 8px;
      }
    }
  }
  .img-no {
    margin: 20px auto 10px auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .img-no-data-word {
      margin: 10px auto;
    }
  }
  .data-title {
    margin-bottom: 10px;
  }
}
</style>
